import React from "react";

export const SlabShowcase = () => {
  return (
    <section id="slab" className="relative py-24 md:py-32" data-testid="slab-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <div className="chip mb-6">The Slab</div>
            <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-white leading-[1.05]">
              A slab that looks<br /> as flawless as its grade.
            </h2>
            <p className="mt-6 text-white/60 text-base md:text-lg leading-relaxed">
              Museum-grade acrylic. Tamper-evident seal. Holographic authentication stripe. The signature sky-blue
              wing embedded with the Blue wordmark — a piece of art for your collection.
            </p>
            <ul className="mt-8 space-y-3 text-white/80 text-sm">
              <li className="flex items-center gap-3"><span className="diamond-mark scale-75" /> UV-resistant optical-grade acrylic</li>
              <li className="flex items-center gap-3"><span className="diamond-mark scale-75" /> Micro-laser engraved cert number</li>
              <li className="flex items-center gap-3"><span className="diamond-mark scale-75" /> QR-linked digital grading report</li>
            </ul>
          </div>

          <div className="lg:col-span-7">
            {/* Recreated slab label — pure CSS/JSX, no external asset */}
            <div className="relative mx-auto max-w-[640px] animate-float-slow">
              <div className="absolute -inset-6 bg-brand/20 blur-3xl rounded-[40px] pointer-events-none" />
              <div
                data-testid="slab-visual"
                className="relative rounded-[22px] overflow-hidden border border-white/15 bg-white shadow-[0_40px_80px_-20px_rgba(79,174,238,0.35)]"
                style={{ aspectRatio: "2.2 / 1" }}
              >
                <div className="absolute inset-0 flex">
                  {/* Left blue panel */}
                  <div
                    className="relative bg-brand text-white flex items-center py-6 pl-5 pr-10"
                    style={{ width: "32%", clipPath: "polygon(0 0, 100% 0, 78% 100%, 0 100%)" }}
                  >
                    <div className="font-logo font-semibold italic text-5xl md:text-7xl leading-none">Blue</div>
                  </div>

                  {/* Right white panel */}
                  <div className="flex-1 relative p-5 md:p-7 grid grid-cols-[1fr_auto] gap-4">
                    <div className="flex flex-col justify-between">
                      <div>
                        <div className="uppercase text-brand font-display font-extrabold tracking-tight text-sm md:text-lg">
                          2023 Panini Prizm
                        </div>
                        <div className="mt-2 md:mt-3 font-display font-black text-black text-xl md:text-3xl tracking-tight leading-none">
                          VICTOR WEMBANYAMA
                        </div>
                        <div className="mt-2 md:mt-3 text-brand font-display font-extrabold uppercase text-xs md:text-base">
                          Silver Prizm
                        </div>
                        <div className="mt-1 text-black/80 font-display font-semibold text-sm md:text-base">#136</div>
                      </div>
                      <div className="mt-2 flex items-end gap-3">
                        <div
                          className="h-8 md:h-10 flex-1 max-w-[200px]"
                          style={{
                            backgroundImage:
                              "repeating-linear-gradient(90deg, #000 0 2px, transparent 2px 4px, #000 4px 5px, transparent 5px 9px)",
                          }}
                          aria-hidden
                        />
                        <div className="text-black font-display font-bold text-xs md:text-sm">
                          <span className="text-brand">BGS</span>214189382
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col items-center justify-center border-l-2 border-black/10 pl-4 md:pl-6 pr-2 md:pr-4">
                      <div className="font-display font-black text-black text-5xl md:text-7xl leading-none">10</div>
                      <div className="mt-2 h-[2px] w-14 md:w-20 bg-brand" />
                      <div className="mt-2 font-display font-black text-black text-[10px] md:text-sm tracking-wide whitespace-nowrap">
                        GEM MINT +
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-6 flex items-center justify-center gap-3 text-white/50 text-xs uppercase tracking-[0.25em]">
                <span className="logo-cursive normal-case text-2xl leading-none text-brand">Blue</span>
                <span>· Every Slab. Every Time.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SlabShowcase;
